import { render, staticRenderFns } from "./HistoricoProposta.vue?vue&type=template&id=548cf1fd&"
import script from "./HistoricoProposta.vue?vue&type=script&lang=js&"
export * from "./HistoricoProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports